import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Slider, Tooltip, Typography } from "antd";
import { useMemo, useState } from "react";
import LineChart from "../../components/charts/apexLineChart";

const { Text } = Typography;

export default function TimeSeriesChartWrapper({ data, isLoading }) {
  const [selectedAggregation, setSelectedAggregation] = useState(10);

  const timegraphData = useMemo(() => {
    if (!data) return null;

    return {
      x: data.historic_time || [],
      y: data.historic_amount_of_people || [],
      xLabel: "Horário",
      yLabel: "Pessoas (média)",
    };
  }, [data]);

  return (
    <Card
      title={
        <span>
          {"Fluxo Diário "}
          <Tooltip title="Inclui apenas detecções de clientes">
            <InfoCircleOutlined style={{ fontSize: 13, color: "#9ca3af" }} />
          </Tooltip>
        </span>
      }
      align="center"
      style={{
        width: "85%",
      }}
      loading={isLoading}
      styles={{
        header: {
          backgroundColor: "var(--ouran-card-header-bg)",
        },
      }}>
      <Row gutter={[16, 8]} className="ouran-chart-slider-row">
        <Col xs={24} sm={12} style={{ textAlign: "right" }}>
          <Text strong style={{ marginRight: 10 }}>
            {"Escolha o período de agregação em minutos:"}
          </Text>
        </Col>
        <Col xs={24} sm={12}>
          <Slider
            defaultValue={10}
            min={1}
            max={30}
            marks={{
              1: "1",
              15: "15",
              30: "30",
            }}
            style={{ width: "100%", maxWidth: "200px" }}
            onChangeComplete={(period) => setSelectedAggregation(period)}
          />
        </Col>
      </Row>
      <LineChart
        title={"Fluxo por horário do dia"}
        data={timegraphData}
        intervalMinutes={selectedAggregation}
        aggregationMode="avg"
      />
    </Card>
  );
}
